import React from "react";
import PropTypes from "prop-types";
import styles from "./css/Styles.scss";
import PriceInput from "./PriceInput";

class QuotableTest extends React.Component {
  handleSelect = event => {
    const { toggleDeleteSelect, quotable } = this.props;
    const selected = event.target.checked;
    toggleDeleteSelect(quotable, selected);
  };

  prices = () => {
    const { quotable } = this.props;
    return [
      {
        quote_item_id: quotable.quote_item_id,
        price: this.priceInput.price(),
        changed: this.priceInput.hasChanged()
      }
    ];
  };

  render() {
    const {
      quotable,
      allowSelect,
      selectedForDeletion,
      rootGroupActions: { priceHasChanged }
    } = this.props;
    const padding = quotable.level * 18 + 10;
    return (
      <tr className={styles.selected}>
        <td>{quotable.quote_as_group ? 0 : ""}</td>
        <td style={{ paddingLeft: padding }}>{quotable.test_name}</td>
        <td>
          {quotable.lod} {quotable.top_unit_name}/{quotable.bottom_unit_name}
        </td>
        <td>{quotable.technique_name}</td>
        <td>{quotable.accreditation_name}</td>
        <td>
          {allowSelect && (
            <input
              type="checkbox"
              onChange={this.handleSelect}
              tabIndex={-1}
              checked={allowSelect && selectedForDeletion}
            />
          )}
        </td>
        <td>
          {quotable.can_add_price && (
            <PriceInput
              ref={ref => (this.priceInput = ref)}
              value={quotable.price}
              onPriceChange={priceHasChanged}
            />
          )}
        </td>
      </tr>
    );
  }
}

export default QuotableTest;
